import React from "react";
import { Link } from "react-router-dom";

const services = [
  {
    url:"/dine#udaan"  ,title: "UDAAN",
    description:
      "Udaan, located near the airport, is aptly named after the spirit of takeoff. Just like flights soaring high, Udaan lifts your dining experience with delicious food and a welcoming ambiance. Whether you're arriving, departing, or just craving great taste, enjoy a perfect meal inspired by freshness, flavor, and flight.",
  },
  {
    url:"/dine#safar"  ,title: "SAFAR",
    description:
      "A Safar is our signature indoor restaurant serving a delightful blend of traditional and modern cuisine. With warm interiors and attentive service, it offers a cozy setting to enjoy delicious meals crafted from the finest ingredients. A perfect destination for family dinners, quiet lunches, or a flavorful culinary escape.",
  },
  {
    url:"/dine#aero"  ,title: "AERO-STAG",
    description:
      "Aero Stag offers a unique dining experience with both elegant indoor seating and breezy poolside ambiance. Enjoy live music, TV shows, and cricket on a wide screen or turn the space into your own private cinema hall. Whether you're relaxing outdoors or immersed indoors, our delicious food, refreshing beverages, and vibrant atmosphere make Aero Stag the perfect spot for memorable moments and flavorful indulgence.",
  },
  {
    url:"/dine#zaika"  ,title: "ZAIKA",
    description:
      "Zaika delivers the rich and vibrant flavors of Delhi with a focus on mouthwatering non-veg dishes. Our professional chefs bring culinary mastery to every plate, blending authentic spices and traditional techniques. Enjoy a flavorful journey through Delhi’s cuisine in a warm, inviting indoor setting perfect for food lovers.",
  },
];

const DiningPage = () => {
  return (
    <div className="services-section">
      <div className="left-panel">
        <h1>Our <span>Dining Services</span></h1>
        <div className="underline"></div>
      </div>
      <div className="container">
        <div className="container-fluid">
        <div className="right-panel">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <h3>{service.title}</h3>
            <div className="underline small"></div>
            <p>{service.description}</p>
           <Link to={service.url}> <button>READ MORE</button></Link>
          </div>
        ))}
      </div>
        </div>
      </div>
    </div>
  );
};

export default DiningPage;
